import React from "react";
import Headers from "../../Components/Header";

const Sell = () => {
	return <Headers />;
};

export default Sell;
